"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgSelectPProgramImgCtl = /** @class */ (function (_super) {
    __extends(DlgSelectPProgramImgCtl, _super);
    function DlgSelectPProgramImgCtl() {
        return _super.call(this, true) || this;
    }
    DlgSelectPProgramImgCtl.prototype.ResetData = function () {
        this.DATA = {
            onSelect: null,
            dialogTitle: "",
            visible: false,
        };
    };
    DlgSelectPProgramImgCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSelectPProgramImgCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgSelectPProgramImgCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSelectPProgramImgCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgSelectPProgramImgCtl.prototype.SetOnSelect = function (callback) {
        this.DATA.onSelect = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectPProgramImgCtl.prototype, "onSelect", {
        get: function () {
            return this.DATA.onSelect;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectPProgramImgCtl.prototype.SetDialogTitle = function (title) {
        this.DATA.dialogTitle = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectPProgramImgCtl.prototype, "dialogTitle", {
        get: function () {
            return this.DATA.dialogTitle;
        },
        enumerable: true,
        configurable: true
    });
    return DlgSelectPProgramImgCtl;
}(BaseController_1.BaseController));
exports.DlgSelectPProgramImgCtl = DlgSelectPProgramImgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSelectPProgramImage.ts
// module id = 905
// module chunks = 0